import React from "react";
// import SocialLinks from "./SocialLinks";

const Footer = () => {
  return (
    <div className="footer__section">
      {/* <div className="footer__section--circle">
        <h2>?</h2>
      </div> */}
      <p>Designed in Figma & Built with React🎯!</p>
      {/* <SocialLinks /> */}
    </div>
  );
};

export default Footer;
